<template>
    <div :class="{'hidden': hidden}" class="pagination-container">
        <el-pagination
            style="margin-top: 20px; text-align: center"
            :background="background"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            :layout="layout"
            :page-sizes="pageSizes"
            :pager-count="pagerCount"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
    </div>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        total: {
            required: true,
            type: Number,
            default: 20
        },
        page: {
            type: Number,
            dafault: 1
        },
        limit: {
            type: Number,
            default: 10
        },
        pageSizes: {
            type: Array,
            default() {
                return [10,20,30,50]
            }
        },
        // 移动端页码按钮默认值的数量为 5
        pagerCount: {
            type: Number,
            default: document.body.clientWidth < 992 ? 5 : 7
        },
        layout: {
            type: String,
            default: 'total, sizes, prev, pager, next, jumper'
        },
        background: {
            type: Boolean,
            default: true
        },
        autoScroll: {
            type: Boolean,
            default: true
        },
        hidden: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        currentPage: {
            get() {
                return this.page
            },
            set(val) {
                console.log('update:page')
                this.$emit('update:page', val)
            }
        },
        pageSize: {
            get() {
                return this.limit
            },
            set(val) {
                console.log('update:limit')
                this.$emit('update:limit', val)
            }
        }
    },
    methods: {
        handleSizeChange(val) {
            this.$emit('pagination', { page: this.currentPage, limit: val })
        },
        handleCurrentChange(val) {
            this.$emit('pagination', { page: val, limit: this.pageSize })
        }
    }
}
</script>

<style scoped>
.pagination-container {
    background: #fff;
    padding: 0;
}
.pagination-container.hidden {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Pagination/index.vue